import './App.scss'
import { Route, Routes } from 'react-router-dom'
import GranKushApp from './modules/components/GranKush-App/GranKush'
import LoginRedirect from './modules/components/Login-Page/Login-Redirect'
import { LightLoadingPageContainer } from './modules/components/Elements/Loading/Light-Loading-Page-Container'
import { UserType } from './modules/types/user-types'
// import { useContext, useEffect } from 'react'
// import { Context } from '.'


type AppPropsType = {
  isAuth: boolean
  user: UserType | null
  initialized: boolean
  preloader: boolean
}


const App: React.FC<AppPropsType> = (props) => {

// const {auth} = useContext(Context)
// const login = () => {
  
// }

  return (
    <div className="App">
      {!props.preloader

        ? <Routes>
          <Route path="/*" element={<GranKushApp user={props.user} />} />
          <Route path="login" element={<LoginRedirect />} />
        </Routes>

        : <div className='preloader__wrapper'><LightLoadingPageContainer /></div>
      }
    </div>

  )
}

export default App
